import Helper from './Helper';

class SingleAccordion {
  constructor(config = {}) {
    const {
      accordions,
      toggles
    } = config;

    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.toggles = Array.prototype.slice.call(document.querySelectorAll(toggles));
    this.currentEl = null;

    if(this.toggles && this.toggles.length !== 0){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.toggles.forEach((el, index) => {
      el.addEventListener('click', (e) => {
        if(this.accordions[index].classList.contains('ns-cv--open')) {
          this.accordions[index].classList.remove("ns-cv--open");
          console.log(this.accordions[index]);
          console.log(this.accordions[index].querySelector('[class*="-extended"]'));
          Helper.slideClose(this.accordions[index].querySelector('[class*="-extended"]'));
        } else {
          this.accordions[index].classList.add("ns-cv--open");
          Helper.slideOpen(this.accordions[index].querySelector('[class*="-extended"]'), true);
        }
      });
    });
  }

}

export default SingleAccordion;
